import request from '@aned/request';

// 导入保存
export async function signOfflineBatch(params) {
  return request('/api/sign/offline/batch', {
    method: 'POST',
    body: params,
    reqType: 'json',
   //  module: 'basic',
  });
}
